import React, { Fragment, useEffect, useRef, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { Flex, Text, Card, Heading, Button, Link } from 'rebass';
import { withWizard } from 'react-albus';
import { Query, withApollo } from 'react-apollo';
import { GET_BRIDGE_POLICY, GET_REGION_ELIGIBILITY, MEMBERSHIP_UPDATE_PAYMENT_CREATE_SESSION } from '../../graphql';
import SpinLoader from '../../components/SpinLoader';
import { OnFileInsuranceBridge } from './components/pickInsurance/onFileInsuranceBridge';
import HardEligibilityForm, { UnauthenticatedHardEligibilityForm } from '../../components/bridge/hardEligibilityForm';
import RevalidateEligibilityForm from '../../components/bridge/RevalidateEligibilityForm';
import { BridgeInsuranceListSelector } from '../scheduleDoctor/components/pickInsurance/BridgeInsuranceListSelector';
import { RegionSelectNotForm } from '../../components/RegionSelect';
import { RadioInputNotForm } from '../../components/RadioInput';
import { PAYERS_LEGACY_FORCED } from '../../utils/bridgeInsurancesBypass';

const BridgeInsurance = ({
  wizard,
  onNonSupportedProviderSelected,
  bypassInsurance,
  isNewPatientFlow,
  notDetected,
  nonServiceStateSelected,
  onStateSelected,
  history,
  setOnFileInsurance,
  useOnFileInsurance,
  setConsents,
  client,
  isWeightloss,
  isMeno,
  locationState,
  session,
}) => {
  if (!!isNewPatientFlow) {
    return (
      <NewPatient
        wizard={wizard}
        onNonSupportedProviderSelected={onNonSupportedProviderSelected}
        bypassInsurance={bypassInsurance}
        isNewPatientFlow={isNewPatientFlow}
        notDetected={notDetected}
        nonServiceStateSelected={nonServiceStateSelected}
        onStateSelected={onStateSelected}
        history={history}
        setOnFileInsurance={setOnFileInsurance}
        useOnFileInsurance={useOnFileInsurance}
        setConsents={setConsents}
        client={client}
        isWeightloss={isWeightloss}
        isMeno={isMeno}
      />
    );
  }
  return (
    <NotNewPatient
      wizard={wizard}
      onNonSupportedProviderSelected={onNonSupportedProviderSelected}
      bypassInsurance={bypassInsurance}
      isNewPatientFlow={isNewPatientFlow}
      notDetected={notDetected}
      nonServiceStateSelected={nonServiceStateSelected}
      onStateSelected={onStateSelected}
      setOnFileInsurance={setOnFileInsurance}
      useOnFileInsurance={(insurance, wizard) => {
        useOnFileInsurance(insurance, wizard);
      }}
      history={history}
      setConsents={setConsents}
      isWeightloss={isWeightloss}
      isMeno={isMeno}
      locationState={locationState}
      session={session}
    />
  );
};

const NotNewPatient = ({ wizard, bypassInsurance, setOnFileInsurance, useOnFileInsurance, session, InsuranceMemberChanged, history, setConsents, isWeightloss, isMeno, locationState = {} }) => {
  const [isAddInsurance, setAddInsurance] = useState(null);
  const [isRevalidateInsurance, setRevalidateInsurance] = useState(false);
  return (
    <Query query={GET_BRIDGE_POLICY} fetchPolicy={'network-only'}>
      {({ loading, error, data }) => {
        if (loading) {
          return (
            <React.Fragment>
              <Flex flex={1} justifyContent="center" alignItems="center" flexDirection={'column'} mt={4}>
                <SpinLoader />
                <Text textAlign="center" mt={4} mb={4} fontSize="18px">
                  Loading Insurances
                </Text>
              </Flex>
            </React.Fragment>
          );
        }

        if (error) {
          return <Text>An error occured</Text>;
        }

        let insurance;
        if (!loading && !error && data) {
          insurance = data.getBridgeOnFileInsurance;
        }
        return (
          <Fragment>
            {!loading &&
              !error && (
                <React.Fragment>
                  {!insurance ? (
                    <>
                      <Flex />
                      {/* {!!session && session.isMember && session.membershipSpecific === 'insurance' ? (
                        // {true === true ? (
                        <Card p={4} mb={4}>
                          <Flex mb={4} flexDirection="column">
                            <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
                              <Flex flexDirection={'column'}>
                                <Heading mt={4} mb={4} textAlign={'center'}>
                                  Let’s Get Your Insurance Information!
                                </Heading>
                                <Text textAlign="center" mb={3}>
                                  Before scheduling your next visit, please upload pictures of your insurance card so that we can confirm your eligibility.
                                </Text>

                                <Button style={{ margin: '0 auto' }} variant="pink" mt={4} onClick={() => history.push('/my-insurances/add')}>
                                  Continue
                                </Button>
                              </Flex>
                            </Flex>
                          </Flex>
                        </Card>
                      ) : (
                        <Flex />
                      )} */}
                    </>
                  ) : (
                    <OnFileInsuranceBridge
                      insurance={insurance}
                      setConsents={(consents) => setConsents(consents)}
                      useOnFileInsurance={(insurance, wizard) => {
                        useOnFileInsurance(insurance, wizard);
                      }}
                      wizard={wizard}
                      session={session}
                      InsuranceMemberChanged={InsuranceMemberChanged}
                      insuranceMemberLost={InsuranceMemberChanged}
                      revalidatePolicy={() => setRevalidateInsurance(true)}
                    />
                  )}
                </React.Fragment>
              )}
            {/* {!!session && session.isMember && session.membershipSpecific === 'insurance' ? (
              <Flex />
            ) : ( */}
            <BridgeInsuranceListSelector
              onContinue={(pyr) => {
                if (pyr && pyr.label) {
                  // console.log({ session });
                  // return;
                  let filteredLegacy; // = PAYERS_LEGACY_FORCED.find((x) => pyr.label.toLowerCase().findIndex((y) => x.payer.toLowerCase()) > -1);

                  for (let index = 0; index < PAYERS_LEGACY_FORCED.length; index++) {
                    const element = PAYERS_LEGACY_FORCED[index];
                    const p = pyr.label;
                    if (p.toLowerCase().indexOf(element.payer.toLowerCase()) > -1) {
                      filteredLegacy = element;
                    }
                  }
                  if (filteredLegacy) {
                    if (filteredLegacy.states.length === 0) {
                      history.push({
                        pathname: isMeno ? '/schedulemeno-legacy/insuranceBenefitsCheck' : isWeightloss ? '/schedulewl-legacy/insuranceBenefitsCheck' : '/schedule-legacy/insuranceBenefitsCheck',
                        state: { ...locationState, legacyPayerName: filteredLegacy.legacyPayerName },
                      });
                      return;
                    } else {
                      if (session && session.department && session.department.departmentId) {
                        if (filteredLegacy.states.indexOf(session.department.departmentId) > -1) {
                          history.push({
                            pathname: isMeno ? '/schedulemeno-legacy/insuranceBenefitsCheck' : isWeightloss ? '/schedulewl-legacy/insuranceBenefitsCheck' : '/schedule-legacy/insuranceBenefitsCheck',
                            state: { ...locationState, legacyPayerName: filteredLegacy.legacyPayerName },
                          });
                          return;
                        }
                      }
                    }
                  }
                  // console.log({ pyr });
                }
                setAddInsurance(pyr);
              }}
              hasInsurance={!!insurance && !!insurance.id}
              onContinueNoInsurance={() => {
                history.push({
                  pathname: isMeno ? '/schedulemeno-legacy/pickDoctor' : isWeightloss ? '/schedulewl-legacy/pickDoctor' : '/schedule-legacy/pickDoctor',
                  state: locationState,
                });
                // history.push(isMeno ? '/schedulemeno-legacy/pickDoctor' : isWeightloss ? '/schedulewl-legacy/pickDoctor' : '/schedule-legacy/pickDoctor');
              }}
            />
            {/* )} */}
            {!!isAddInsurance && (
              <HardEligibilityForm
                defaultPayer={isAddInsurance}
                onContinue={(policy) => setOnFileInsurance(policy, true)}
                onCancel={() => setAddInsurance(null)}
                setConsents={(consents) => setConsents(consents)}
                onContinueNoInsurance={() => {
                  history.push({
                    pathname: isMeno ? '/schedulemeno-legacy/pickDoctor' : isWeightloss ? '/schedulewl-legacy/pickDoctor' : '/schedule-legacy/pickDoctor',
                    state: locationState,
                  });
                  // history.push(isMeno ? '/schedulemeno-legacy/pickDoctor' : isWeightloss ? '/schedulewl-legacy/pickDoctor' : '/schedule-legacy/pickDoctor');
                }}
              />
            )}
            {!!isRevalidateInsurance && (
              <RevalidateEligibilityForm
                insurance={insurance}
                onCancel={() => isRevalidateInsurance(null)}
                forceNewInsurance={() => {
                  isRevalidateInsurance(null);
                  setAddInsurance(true);
                }}
                onContinue={() => {
                  useOnFileInsurance(insurance, wizard);
                }}
                onContinueNoInsurance={() => {
                  bypassInsurance();
                }}
              />
            )}
          </Fragment>
        );
      }}
    </Query>
  );
};

const NewPatient = ({
  wizard,
  onNonSupportedProviderSelected,
  bypassInsurance,
  isNewPatientFlow,
  notDetected,
  nonServiceStateSelected,
  onStateSelected,
  history,
  setOnFileInsurance,
  useOnFileInsurance,
  setConsents,
  client,
  isWeightloss,
  isMeno,
}) => {
  const [patientState, setPatientState] = useState();
  const [isNotServicedState, setisNotServicedState] = useState();
  const [regionEligibility, setregionEligibility] = useState();
  const [detected, setDetected] = useState();
  const cardDiagnosed = useRef();
  const cardSelectInsurance = useRef();
  const [isAddInsurance, setAddInsurance] = useState(null);
  const [isRevalidateInsurance, setRevalidateInsurance] = useState(false);
  useEffect(
    () => {
      if (!regionEligibility) return;

      if (regionEligibility !== 'full' && regionEligibility !== 'visit') {
        nonServiceStateSelected(wizard);
      } else {
        setTimeout(() => {
          if (cardDiagnosed && cardDiagnosed.current) {
            cardDiagnosed.current.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
              inline: 'nearest',
            });
          }
        }, 300);
      }
    },
    [detected]
  );

  useEffect(
    () => {
      if (patientState) {
        checkStateEligibility();
      }
    },
    [patientState]
  );

  const checkStateEligibility = async () => {
    try {
      const stateEligibility = await client.query({
        query: GET_REGION_ELIGIBILITY,
        variables: {
          state: patientState,
        },
      });
      if (
        !stateEligibility ||
        !stateEligibility.data ||
        !stateEligibility.data.getRegionEligibility ||
        (stateEligibility.data.getRegionEligibility !== 'full' && stateEligibility.data.getRegionEligibility !== 'visit' && stateEligibility.data.getRegionEligibility !== 'kit')
      ) {
        setregionEligibility(!stateEligibility || !stateEligibility.data || !stateEligibility.data.getRegionEligibility ? 'none' : stateEligibility.data.getRegionEligibility);
        setisNotServicedState(true);
        nonServiceStateSelected(wizard);
      } else {
        setregionEligibility(!stateEligibility || !stateEligibility.data || !stateEligibility.data.getRegionEligibility ? 'none' : stateEligibility.data.getRegionEligibility);
        setTimeout(() => {
          if (cardDiagnosed && cardDiagnosed.current) {
            cardDiagnosed.current.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center',
            });
          }
        }, 300);
      }
    } catch (error) {
      console.log('ELIGIBI err', error);
    }
  };
  return (
    <>
      <Card p={4} mb="42px">
        <Flex mb={4} flexDirection="column">
          <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
            <Heading textAlign="center" mb={4}>
              In which state are you located?
            </Heading>
            <div
              style={{
                maxWidth: '500px',
                alignSelf: 'center',
                width: '100%',
              }}
            >
              <RegionSelectNotForm
                value={patientState}
                style={{ width: '100%' }}
                onSelectionChange={(val) => {
                  onStateSelected(val);
                  setPatientState(val);
                }}
              />
            </div>
          </Flex>
        </Flex>
      </Card>
      <span style={{ textAlign: 'center', marginBottom: '42px' }}>
        <Text style={{ display: 'inline' }}>Already have an account? &nbsp;</Text>
        <Link to="/schedule" id="link_login">
          Sign In
        </Link>
      </span>
      {patientState && (
        <Card p={4} mb={5} ref={cardDiagnosed}>
          <Flex mb={4} flexDirection="column">
            <Flex flex={1} justifyContent="center" alignItems="center" flexDirection="column">
              <Heading textAlign="center" mb={4}>
                Have you been diagnosed with hypothyroidism?
              </Heading>
              <Flex flexDirection="row">
                <RadioInputNotForm
                  onChecked={() => {
                    if (regionEligibility !== 'full' && regionEligibility !== 'visit') {
                      setisNotServicedState(true);
                      setDetected(true);
                    } else {
                      setDetected(true);
                    }
                  }}
                  checked={detected}
                  label="Yes"
                  style={{ marginRight: '24px' }}
                />
                <RadioInputNotForm
                  onChecked={() => {
                    // notDetected(wizard);
                  }}
                  checked={detected === false}
                  label="No"
                />
              </Flex>
            </Flex>
          </Flex>
        </Card>
      )}
      {patientState &&
        detected === true && (
          <div ref={cardSelectInsurance}>
            <BridgeInsuranceListSelector
              onContinue={(pyr) => {
                setAddInsurance(pyr);
              }}
              onContinueNoInsurance={() => {
                history.push(isWeightloss ? '/schedulewl-legacy/pickDoctor' : isMeno ? '/schedulemeno-legacy/pickDoctor' : '/book-appointment-legacy/pickDoctor');
              }}
            />
          </div>
        )}
      {!!isAddInsurance && (
        <UnauthenticatedHardEligibilityForm
          defaultPayer={isAddInsurance}
          onContinue={(policy) => setOnFileInsurance(policy, true)}
          onCancel={() => setAddInsurance(null)}
          setConsents={(consents) => setConsents(consents)}
        />
      )}
    </>
  );
};

export const BridgeInsuranceNoWizard = withRouter(withApollo(BridgeInsurance));

export default withRouter(withApollo(withWizard(BridgeInsurance)));
